"use client"

import { useState } from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Badge } from "../../../components/ui/badge"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select"
import { Search, Eye, Edit, Trash2, UserPlus } from "lucide-react"

const users = [
  {
    id: 1,
    name: "John Doe",
    email: "john.doe@tso-emails.com",
    role: "Admin",
    status: "Active",
    registrationDate: "2024-01-15",
    lastLogin: "2024-01-06",
  },
  {
    id: 2,
    name: "Mary Smith",
    email: "mary.smith@tso-emails.com",
    role: "Editor",
    status: "Active",
    registrationDate: "2024-01-10",
    lastLogin: "2024-01-05",
  },
  {
    id: 3,
    name: "David Wilson",
    email: "david.wilson@tso-emails.com",
    role: "User",
    status: "Inactive",
    registrationDate: "2023-12-20",
    lastLogin: "2023-12-25",
  },
]

// export function UserManagementSection({allUsers,adminUsers,comments}:any) {
//   const [searchTerm, setSearchTerm] = useState("")
//   const [roleFilter, setRoleFilter] = useState("all")
//   const [selectedUser, setSelectedUser] = useState<(typeof users)[0] | null>(null)

//   const filteredUsers = users.filter((user) => {
//     const matchesSearch =
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.email.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesRole = roleFilter === "all" || user.role.toLowerCase() === roleFilter
//     return matchesSearch && matchesRole
//   })

//   const getRoleBadgeVariant = (role: string) => {
//     switch (role.toLowerCase()) {
//       case "admin":
//         return "destructive"
//       case "editor":
//         return "default"
//       case "reviewer":
//         return "secondary"
//       default:
//         return "outline"
//     }
//   }

//   const getStatusBadgeVariant = (status: string) => {
//     return status === "Active" ? "default" : "secondary"
//   }

//   return (
//     <div className="space-y-6">
//       <Card>
//         <CardHeader>
//           <CardTitle>User Management</CardTitle>
//           <CardDescription>Manage users, roles, and access control for the ministry platform</CardDescription>
//         </CardHeader>
//         {/* <p>{JSON.stringify(allUsers)}</p> */}
//         <CardContent>
//           <div className="flex flex-col sm:flex-row gap-4 mb-6">
//             <div className="relative flex-1">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
//               <Input
//                 placeholder="Search users by name or email..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="pl-10"
//               />
//             </div>
//             <Select value={roleFilter} onValueChange={setRoleFilter}>
//               <SelectTrigger className="w-full sm:w-[180px]">
//                 <SelectValue placeholder="Filter by role" />
//               </SelectTrigger>
//               <SelectContent>
//                 <SelectItem value="all">All Roles</SelectItem>
//                 <SelectItem value="admin">Admin</SelectItem>
//                 <SelectItem value="editor">Editor</SelectItem>
//                 <SelectItem value="reviewer">Reviewer</SelectItem>
//                 <SelectItem value="user">User</SelectItem>
//               </SelectContent>
//             </Select>
//             <Button>
//               <UserPlus className="h-4 w-4 mr-2" />
//               Add User
//             </Button>
//           </div>

//           <div className="rounded-md border">
//             <Table>
//               <TableHeader>
//                 <TableRow>
//                   <TableHead>Name</TableHead>
//                   <TableHead>Email</TableHead>
//                   <TableHead>Role</TableHead>
//                   <TableHead>Status</TableHead>
//                   <TableHead>Last Login</TableHead>
//                   <TableHead className="text-right">Actions</TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 {filteredUsers.map((user) => (
//                   <TableRow key={user.id}>
//                     <TableCell className="font-medium">{user.name}</TableCell>
//                     <TableCell>{user.email}</TableCell>
//                     <TableCell>
//                       <Badge variant={getRoleBadgeVariant(user.role)}>{user.role}</Badge>
//                     </TableCell>
//                     <TableCell>
//                       <Badge variant={getStatusBadgeVariant(user.status)}>{user.status}</Badge>
//                     </TableCell>
//                     <TableCell>{user.lastLogin}</TableCell>
//                     <TableCell className="text-right">
//                       <div className="flex justify-end gap-2">
//                         <Dialog>
//                           <DialogTrigger asChild>
//                             <Button variant="ghost" size="sm" onClick={() => setSelectedUser(user)}>
//                               <Eye className="h-4 w-4" />
//                             </Button>
//                           </DialogTrigger>
//                           <DialogContent>
//                             <DialogHeader>
//                               <DialogTitle>User Details</DialogTitle>
//                               <DialogDescription>View and manage user information</DialogDescription>
//                             </DialogHeader>
//                             {selectedUser && (
//                               <div className="space-y-4">
//                                 <div>
//                                   <label className="text-sm font-medium">Name</label>
//                                   <p className="text-sm text-muted-foreground">{selectedUser.name}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Email</label>
//                                   <p className="text-sm text-muted-foreground">{selectedUser.email}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Role</label>
//                                   <p className="text-sm text-muted-foreground">{selectedUser.role}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Registration Date</label>
//                                   <p className="text-sm text-muted-foreground">{selectedUser.registrationDate}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Last Login</label>
//                                   <p className="text-sm text-muted-foreground">{selectedUser.lastLogin}</p>
//                                 </div>
//                                 <div className="flex gap-2 pt-4">
//                                   <Button size="sm">Edit Role</Button>
//                                   <Button variant="outline" size="sm">
//                                     Reset Password
//                                   </Button>
//                                 </div>
//                               </div>
//                             )}
//                           </DialogContent>
//                         </Dialog>
//                         <Button variant="ghost" size="sm">
//                           <Edit className="h-4 w-4" />
//                         </Button>
//                         <Button variant="ghost" size="sm">
//                           <Trash2 className="h-4 w-4" />
//                         </Button>
//                       </div>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   )
// }



export function UserManagementSection({ allUsers }: any) {
  const [searchTerm, setSearchTerm] = useState("")
  const [roleFilter, setRoleFilter] = useState("all")
  const [selectedUser, setSelectedUser] = useState<any | null>(null)
  const USERS_PER_PAGE = 20
  const [currentPage, setCurrentPage] = useState(1)

  // 🧠 Transform the users here
  const users = allUsers.map((user: any) => {
    const name =
      (user.first_name || user.last_name)
        ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
        : user.name || user.nickname || "Unnamed"

    const role = user.roles?.[0]?.toLowerCase() || "user"

    return {
      id: user.id,
      name,
      email: user.email,
      role: capitalize(role), // e.g. "admin", "editor", etc.
      status: user.is_verified === "1" ? "Active" : "Inactive",
      registrationDate: new Date(user.registered_date).toLocaleDateString(),
      lastLogin: "N/A", // Could be extended if login tracking is added
    }
  })

  const filteredUsers = users.filter((user: any) => {
    const matchesSearch =
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesRole = roleFilter === "all" || user.role.toLowerCase() === roleFilter
    return matchesSearch && matchesRole
  })

  const totalPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE)

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * USERS_PER_PAGE,
    currentPage * USERS_PER_PAGE
  )

  const getRoleBadgeVariant = (role: string) => {
    switch (role.toLowerCase()) {
      case "admin":
      case "administrator":
        return "destructive"
      case "editor":
        return "default"
      case "reviewer":
        return "secondary"
      default:
        return "outline"
    }
  }

  const getStatusBadgeVariant = (status: string) => {
    return status === "Active" ? "default" : "secondary"
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>User Management</CardTitle>
          <CardDescription>
            Manage users, roles, and access control for the ministry platform
          </CardDescription>
        </CardHeader>

        <CardContent>
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search users by name or email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
              />
            </div>
            <Select value={roleFilter} onValueChange={setRoleFilter}>
              <SelectTrigger className="w-full sm:w-[180px]">
                <SelectValue placeholder="Filter by role" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Roles</SelectItem>
                <SelectItem value="administrator">Admin</SelectItem>
                <SelectItem value="editor">Editor</SelectItem>
                <SelectItem value="reviewer">Reviewer</SelectItem>
                <SelectItem value="subscriber">User</SelectItem>
              </SelectContent>
            </Select>
            <Button>
              <UserPlus className="h-4 w-4 mr-2" />
              Add User
            </Button>
          </div>

          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Email</TableHead>
                  <TableHead>Role</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Signup Date</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {paginatedUsers.map((user: any) => (
                  <TableRow key={user.id}>
                    <TableCell className="font-medium">{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Badge variant={getRoleBadgeVariant(user.role)}>{user.role}</Badge>
                    </TableCell>
                    <TableCell>
                      <Badge variant={getStatusBadgeVariant(user.status)}>{user.status}</Badge>
                    </TableCell>
                    <TableCell>{user.registrationDate}</TableCell>
                    <TableCell className="text-right">
                      <div className="flex justify-end gap-2">
                        <Dialog>
                          <DialogTrigger asChild>
                            <Button variant="ghost" size="sm" onClick={() => setSelectedUser(user)}>
                              <Eye className="h-4 w-4" />
                            </Button>
                          </DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>User Details</DialogTitle>
                              <DialogDescription>
                                View and manage user information
                              </DialogDescription>
                            </DialogHeader>
                            {selectedUser && (
                              <div className="space-y-4">
                                <div>
                                  <label className="text-sm font-medium">Name</label>
                                  <p className="text-sm text-muted-foreground">{selectedUser.name}</p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Email</label>
                                  <p className="text-sm text-muted-foreground">{selectedUser.email}</p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Role</label>
                                  <p className="text-sm text-muted-foreground">{selectedUser.role}</p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Registration Date</label>
                                  <p className="text-sm text-muted-foreground">
                                    {selectedUser.registrationDate}
                                  </p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Last Login</label>
                                  <p className="text-sm text-muted-foreground">{selectedUser.lastLogin}</p>
                                </div>
                                <div className="flex gap-2 pt-4">
                                  <Button size="sm">Edit Role</Button>
                                  <Button variant="outline" size="sm">
                                    Reset Password
                                  </Button>
                                </div>
                              </div>
                            )}
                          </DialogContent>
                        </Dialog>
                        <Button variant="ghost" size="sm">
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button variant="ghost" size="sm">
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="flex items-center justify-between mt-4">
            <p className="text-sm text-muted-foreground">
              Showing {(currentPage - 1) * USERS_PER_PAGE + 1}–
              {Math.min(currentPage * USERS_PER_PAGE, filteredUsers.length)} of {filteredUsers.length} users
            </p>
            <div className="flex items-center gap-1">
              <Button variant="outline" size="sm" disabled={currentPage === 1} onClick={() => setCurrentPage(1)}>
                First
              </Button>
              <Button variant="outline" size="sm" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
                Prev
              </Button>

              {[...Array(totalPages)].map((_, idx) => {
                const page = idx + 1
                return (
                  <Button
                    key={page}
                    variant={currentPage === page ? "default" : "outline"}
                    size="sm"
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Button>
                )
              }).slice(
                Math.max(0, currentPage - 3),
                Math.min(currentPage + 2, totalPages)
              )}

              <Button variant="outline" size="sm" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}>
                Next
              </Button>
              <Button variant="outline" size="sm" disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)}>
                Last
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

function capitalize(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1)
}